export default __webpack_public_path__ + "static/media/expert_advice.5399fefc.png";